module.exports = __webpack_public_path__ + "static/media/activeuser.42da057e.png";